export const routeNameEcommerceVersion1= {
  HOMEPAGE: '/ecommerceversion1',
  PRODUCTVIEW: '/ecommerceversion1/productView',
  CART: '/ecommerceversion1/cart',
  SEARCHPRODUCT: '/ecommerceversion1/searchProduct'
}